"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect, useRef, useState } from "react";
var INITIAL_STATE = {};
var DEFAULT_RECT_TYPES = ["entry"];
export function useMeasureV2(ref, types) {
    if (types === void 0) { types = ["bounds"]; }
    var _a = __read(useState(INITIAL_STATE), 2), state = _a[0], setState = _a[1];
    var observer = useRef();
    var animationID = useRef();
    var node = ref.current;
    var measure = function (entries) {
        if (!node)
            return;
        var rects = getNodeRect(node, types);
        if (entries) {
            rects.entry = entries[0].contentRect;
        }
        animationID.current = requestAnimationFrame(function () {
            if (!observer.current)
                return;
            setState(rects);
        });
    };
    useEffect(function () {
        if (!node)
            return;
        observer.current = new ResizeObserver(measure);
        observer.current.observe(node);
        return function () {
            observer.current.disconnect();
            if (typeof animationID.current === "number") {
                cancelAnimationFrame(animationID.current);
            }
        };
    }, [node]);
    return __assign(__assign({}, state), { el: node });
}
export var useMeasure = function (types) {
    var _a = __read(useState(INITIAL_STATE), 2), state = _a[0], setState = _a[1];
    var _b = __read(useState(null), 2), node = _b[0], setNode = _b[1];
    var observer = useRef();
    var animationID = useRef();
    var ref = useCallback(function (node) { return setNode(node); }, []);
    var measure = function (entries) {
        if (!node)
            return;
        var rects = getNodeRect(node, types);
        if (entries) {
            rects.entry = entries[0].contentRect;
        }
        animationID.current = requestAnimationFrame(function () {
            if (!observer.current)
                return;
            setState(rects);
        });
    };
    useEffect(function () {
        if (!node)
            return;
        observer.current = new ResizeObserver(measure);
        observer.current.observe(node);
        return function () {
            observer.current.disconnect();
            if (typeof animationID.current === "number") {
                cancelAnimationFrame(animationID.current);
            }
        };
    }, [node]);
    return [
        ref,
        __assign(__assign({}, state), { el: node }),
    ];
};
function getNodeRect(el, types) {
    if (types === void 0) { types = DEFAULT_RECT_TYPES; }
    var rects = {};
    if (types.indexOf("bounds") > -1) {
        var bounds = el.getBoundingClientRect();
        var top_1 = bounds.top;
        var left = bounds.left;
        var width = bounds.width;
        var height = bounds.height;
        rects.bounds = {
            top: top_1,
            right: left + width,
            bottom: top_1 + height,
            left: left,
            width: width,
            height: height,
        };
    }
    if (types.indexOf("client") > -1) {
        var top_2 = el.clientTop;
        var left = el.clientLeft;
        var width = el.clientWidth;
        var height = el.clientHeight;
        rects.client = {
            top: top_2,
            right: left + width,
            bottom: top_2 + height,
            left: left,
            width: width,
            height: height,
        };
    }
    if (types.indexOf("margin") > -1) {
        var styles = getComputedStyle(el);
        var top_3 = styles ? parseInt(styles.marginTop) : 0;
        var right = styles ? parseInt(styles.marginRight) : 0;
        var bottom = styles ? parseInt(styles.marginBottom) : 0;
        var left = styles ? parseInt(styles.marginLeft) : 0;
        rects.margin = {
            top: top_3,
            right: right,
            bottom: bottom,
            left: left,
        };
    }
    if (types.indexOf("offset") > -1) {
        var top_4 = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;
        rects.offset = {
            top: top_4,
            right: left + width,
            bottom: top_4 + height,
            left: left,
            width: width,
            height: height,
        };
    }
    if (types.indexOf("scroll") > -1) {
        var top_5 = el.scrollTop;
        var left = el.scrollLeft;
        var width = el.scrollWidth;
        var height = el.scrollHeight;
        rects.scroll = {
            top: top_5,
            right: left + width,
            bottom: top_5 + height,
            left: left,
            width: width,
            height: height,
        };
    }
    return rects;
}
